import React from "react";
import {MenuItemProps} from "./types";
import {ListItemIcon, MenuItem} from "@mui/material";
import {Logout} from "@mui/icons-material";

const LogoutItem: React.FC<MenuItemProps> = (
    {
        handleCloseParent
    }
) => {
    return (
        <MenuItem color={'secondary'} onClick={handleCloseParent}>
            <ListItemIcon>
                <Logout/>
            </ListItemIcon>
            Выход
        </MenuItem>
    )
}

export default LogoutItem;